import "bootstrap/dist/css/bootstrap.min.css";
import { FaBook, FaLink, FaCode, FaCheckCircle } from "react-icons/fa";
import { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";

export default function Nextradiobutton() {
  const sectionHeaderStyle = {
    borderBottom: "2px solid #007bff",
    paddingBottom: "5px",
    marginBottom: "15px",
    fontSize: "1.2rem",
    fontWeight: "bold",
    color: "#007bff",
    display: "flex",
    alignItems: "center",
    gap: "8px",
  };

  return (
    <div style={{ backgroundColor: "#f8f9fa", minHeight: "100vh", padding: "40px 20px" }}>
      <div className="container bg-white p-5 shadow-sm rounded">
        <h1 className="fw-bold mb-5 text-primary text-center">
          Radio Button - Next.js
        </h1>

        {/* Step 1: State and Base URL */}
        <section className="mb-5">
          <div style={sectionHeaderStyle}>
            <FaBook /> Step 1: State and Base URL
          </div>
          <pre style={preStyle}>{`const [students, setStudents] = useState([]);
const [countries, setCountries] = useState([]);
const [states, setStates] = useState([]);
const [districts, setDistricts] = useState([]);
const [id, setId] = useState(0);
const [firstName, setFirstName] = useState("");
const [middleName, setMiddleName] = useState("");
const [lastName, setLastName] = useState("");
const [address, setAddress] = useState("");
const [email, setEmail] = useState("");
const [mobile, setMobile] = useState("");
const [countryId, setCountryId] = useState("");
const [stateId, setStateId] = useState("");
const [districtId, setDistrictId] = useState("");
const [genderId, setGenderId] = useState(0);
const genders = [{ id: 1, name: "Male" }, { id: 2, name: "Female"}, {id:3,name:"Other"}];
const baseUrl = process.env.NEXT_PUBLIC_BASE_URL;`}</pre>
        </section>

        {/* Step 2: Load Data */}
        <section className="mb-5">
          <div style={sectionHeaderStyle}>
            <FaLink /> Step 2: Load Data from APIs
          </div>
          <pre style={preStyle}>{`useEffect(() => {
  loadStudents();
  loadCountries();
  loadStates();
  loadDistricts();
}, []);

const loadStudents = async () => {
  const res = await axios.get(\`\${baseUrl}/students\`);
  setStudents(res.data);
};

const loadCountries = async () => {
  const res = await axios.get(\`\${baseUrl}/countries\`);
  setCountries(res.data);
};

const loadStates = async () => {
  const res = await axios.get(\`\${baseUrl}/states\`);
  setStates(res.data);
};

const loadDistricts = async () => {
  const res = await axios.get(\`\${baseUrl}/districts\`);
  setDistricts(res.data);
};`}</pre>
        </section>

        {/* Step 3: Toast Notifications */}
        <section className="mb-5">
          <div style={sectionHeaderStyle}>
            <FaCheckCircle /> Step 3: Toast Notifications
          </div>
          <pre style={preStyle}>{`const toast = (icon, title) => {
  Swal.fire({
    toast: true,
    position: "top-end",
    icon,
    title,
    showConfirmButton: false,
    timer: 2000,
    timerProgressBar: true
  });
};`}</pre>
        </section>

        {/* Step 4: Add / Update Student */}
        <section className="mb-5">
          <div style={sectionHeaderStyle}>
            <FaCode /> Step 4: Add or Update Student
          </div>
          <pre style={preStyle}>{`const handleSubmit = async (e) => {
  e.preventDefault();

  const payload = {
    id,
    firstName,
    middleName,
    lastName,
    address,
    email,
    mobile,
    countryId: countryId ? Number(countryId) : null,
    stateId: stateId ? Number(stateId) : null,
    districtId: districtId ? Number(districtId) : null,
    genderId: genderId ? Number(genderId) : null
  };

  if (id > 0) {
    await axios.put(\`\${baseUrl}/students\`, payload);
    Swal.fire("Updated!", "Student record has been updated.", "success");
  } else {
    await axios.post(\`\${baseUrl}/students\`, payload);
    Swal.fire("Added!", "New student has been added.", "success");
  }

  resetForm();
  loadStudents();
};`}</pre>
        </section>

        {/* Step 5: Edit Student */}
        <section className="mb-5">
          <div style={sectionHeaderStyle}>
            <FaBook /> Step 5: Edit Student
          </div>
          <pre style={preStyle}>{`const handleEdit = (std) => {
  setId(std.id);
  setFirstName(std.firstName);
  setMiddleName(std.middleName);
  setLastName(std.lastName);
  setAddress(std.address);
  setEmail(std.email);
  setMobile(std.mobile);
  setCountryId(std.countryId);
  setStateId(std.stateId);
  setDistrictId(std.districtId);
  setGenderId(std.genderId || 0);
};`}</pre>
        </section>

        {/* Step 6: Delete Student */}
        <section className="mb-5">
          <div style={sectionHeaderStyle}>
            <FaLink /> Step 6: Delete Student
          </div>
          <pre style={preStyle}>{`const handleDelete = (studentId) => {
  Swal.fire({
    title: "Are you sure?",
    text: "You won't be able to revert this!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Yes, delete it!",
    cancelButtonText: "Cancel"
  }).then(async (result) => {
    if (result.isConfirmed) {
      await axios.delete(\`\${baseUrl}/students/\${studentId}\`);
      loadStudents();
      Swal.fire("Deleted!", "Student has been deleted.", "success");
    }
  });
};`}</pre>
        </section>

        {/* Step 7: Component JSX */}
        <section className="mb-5">
          <div style={sectionHeaderStyle}>
            <FaCode /> Step 7: Component JSX
          </div>
          <pre style={preStyle}>{`<form onSubmit={handleSubmit} className="mb-4">
  <!-- Inputs -->
  <input type="text" value={firstName} onChange={e => setFirstName(e.target.value)} />
  <input type="text" value={middleName} onChange={e => setMiddleName(e.target.value)} />
  <input type="text" value={lastName} onChange={e => setLastName(e.target.value)} />
  <input type="text" value={address} onChange={e => setAddress(e.target.value)} />
  <input type="email" value={email} onChange={e => setEmail(e.target.value)} />
  <input type="text" value={mobile} onChange={e => setMobile(e.target.value)} />

  <!-- Selects -->
  <select value={countryId} onChange={e => setCountryId(e.target.value)}>
    <option value="">Select Country</option>
    {countries.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
  </select>
  <select value={stateId} onChange={e => setStateId(e.target.value)}>
    <option value="">Select State</option>
    {states.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
  </select>
  <select value={districtId} onChange={e => setDistrictId(e.target.value)}>
    <option value="">Select District</option>
    {districts.map(d => <option key={d.id} value={d.id}>{d.name}</option>)}
  </select>

  <!-- Radio buttons for gender -->
  {genders.map(g => (
    <label key={g.id}>
      <input type="radio" name="gender" value = {g.id} checked = {genderId === g.id} 
              onChange={e => setGenderId(Number(e.target.value))} />
      {g.name}
    </label>
  ))}

  <button type="submit">{id > 0 ? "Update Student" : "Add Student"}</button>
  <button type="button" onClick={resetForm}>Cancel</button>
</form>

<table className="table table-bordered table-striped">
  <thead>
    <tr>
      <th>Name</th>
      <th>Email</th>
      <th>Country</th>
      <th>State</th>
      <th>District</th>
      <th>Gender</th>
      <th>Actions</th>
    </tr>
  </thead>
  <tbody>
    {students.map(std => (
      <tr key={std.id}>
        <td>{\`\${std.firstName} \${std.middleName || ""} \${std.lastName}\`}</td>
        <td>{std.email}</td>
        <td>{countries.find(c => c.id === std.countryId)?.name}</td>
        <td>{states.find(s => s.id === std.stateId)?.name}</td>
        <td>{districts.find(d => d.id === std.districtId)?.name}</td>
        <td>{genders.find(g => g.id === std.genderId)?.name}</td>
        <td>
          <button className="btn btn-sm me-2" onClick={()=>handleEdit(std)}>Edit</button>
          <button className="btn btn-sm" onClick={()=>handleDelete(std.id)}>Dele</button>
        </td>
      </tr>
    ))}
  </tbody>
</table>`}</pre>
        </section>

        {/* Step 8: Summary */}
        <section>
          <div style={sectionHeaderStyle}>
            <FaBook /> Step 8: Summary
          </div>
          <ul style={{ fontSize: "1.1rem", lineHeight: "1.6" }}>
            <li>✅ Full CRUD operations with Axios (GET, POST, PUT, DELETE)</li>
            <li>🟡 SweetAlert2 used for notifications and delete confirmation</li>
            <li>📝 Form handling with controlled components</li>
            <li>📋 Dynamic table rendering of students with Edit & Delete actions</li>
            <li>⚡ Gender selection via radio buttons</li>
          </ul>
        </section>
      </div>
    </div>
  );
}

// Shared preStyle
const preStyle = {
  backgroundColor: "#f1f3f5",
  fontFamily: "monospace",
  fontSize: "0.95rem",
  border: "1px solid #dee2e6",
  padding: "15px",
  borderRadius: "5px",
  overflowX: "auto",
  whiteSpace: "pre",
};
